"use client";

import React from "react";
import { Box, Container } from "@mui/material";
import ScrollToTop from "../common/ScrollToTop";
import TermsAndCondition from "./terms-and-condition/TermsAndConditions";

// export const TabButton: React.FC<{
//   title: string;
//   icon: React.ReactElement;
//   onClick?(): void;
//   selected: boolean;
//   href: string;
// }> = ({ title, icon, onClick, selected, href }) => {
//   return (
//     <>
//       <Link href={href}>
//         <Box
//           sx={{
//             p: "1rem",
//             border: selected ? "1px solid #060273" : "1px solid #ccc",
//             width: "100%",
//             height: { xs: "inherit", md: "54px" },
//             borderRadius: "10px",
//             cursor: "pointer",
//             boxShadow: "0px 2px 15px rgba(0,0,0,0.15)",
//             color: selected ? "#060273" : "#222",
//             textDecoration: "none",
//             display: "flex",
//             alignItems: "center",
//             gap: "10px",
//             margin: "10px 0",
//             backgroundColor: "#ffffff",
//           }}
//           onClick={onClick}
//         >
//           <Box
//             sx={{
//               svg: {
//                 width: "30px",
//                 height: "30px",
//               },
//               display: "flex",
//               alignItems: "center",
//             }}
//           >
//             {icon}
//           </Box>
//           <Box sx={{ fontSize: "1rem", fontWeight: 500, color: "#060273" }}>
//             {title}
//           </Box>
//         </Box>
//       </Link>
//     </>
//   );
// };

const HelpAndSupportBanner: React.FC = () => {
  // const [selectedHeading, setSelectedHeading] = useState("");

  // const pathname = useSearchParams();

  // useEffect(() => {
  //   const id = pathname?.get("id") || "terms-and-conditions";
  //   setSelectedHeading(id);
  //   const element = document.getElementById("helpAndSupportContent");

  //   if (element && id) {
  //     window.scrollTo({
  //       top: element.offsetTop + 205,
  //       behavior: "smooth",
  //     });
  //   }
  // }, [pathname]);

  return (
    <Box sx={{ position: "relative" }}>
      {/* <HelpSupportBanner /> */}

      <Container sx={{ marginTop: "1rem" }}>
        {/* <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr",
              sm: "1fr 1fr",
              md: "repeat(4, 1fr)",
            },
            alignItems: "center",
            gap: "1rem",
            mt: "2rem",
            position: { xs: "relative", md: "sticky" },
            top: { xs: "0px", md: "90px" },
            zIndex: { xs: 2, md: 99 },
          }}
        >
          <TabButton
            title="Terms and Conditions"
            icon={<TermsIcon />}
            selected={selectedHeading == "terms-and-conditions"}
            href={"?id=terms-and-conditions"}
          />

        </Box> */}

        <Box id="helpAndSupportContent">
          <TermsAndCondition />
        </Box>
      </Container>
      <ScrollToTop isLeftAlign />
    </Box>
  );
};
export default HelpAndSupportBanner;
